export const detectmob = () => {
  console.log('l99',window.orientation )
    if (window.orientation > -1) {
        return true;
    } else {
        return false;
    }
};